export const CSS_CLASSES = {
    DATA_TABLE: 'widget--requests__data-table',
	WIDGET: 'widget--requests',
	WIDGET_EMPTY: 'widget--requests__card--empty',
	WIDGET_REFRESHING: 'widget--requests--refreshing',
};

/**
 * Maximum number of rows to render.
 * @type {Number}
 */
export const MAX_ROWS = 5;

/**
 * Maximum number of characters to permit in a `DataTable` cell before splicing content.
 * @type {Number}
 */
export const MAX_CHAR_CELL = 28;